import { render, staticRenderFns } from "./UploadSoundFile.vue?vue&type=template&id=32fb2767&"
import script from "./UploadSoundFile.vue?vue&type=script&lang=js&"
export * from "./UploadSoundFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports